import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledClear = styled.div`
  display: flex;
  justify-content: flex-end;
`;
const ClearButton = styled.button`
  color: ${p => p.theme.colors.primary};
  cursor: pointer;
  font-size: 0.875rem;
  border: none;
  padding: 0;
  margin-bottom: 5px;
`;

export default function Clear({ onClearClick }) {
  return (
    <StyledClear>
      <ClearButton onClick={onClearClick}>Nullstill</ClearButton>
    </StyledClear>
  );
}

Clear.propTypes = {
  onClearClick: PropTypes.func.isRequired
};
